























import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import wtVideo from "@/components/custom/wtVideo/index.vue";
import wtImage from "@/components/custom/wtImage/index.vue";
import CustomPageSection from "@/components/custom/CustomPageSection.vue";

const common = namespace("common");
const storeManage = namespace("storeManage");

const wt = namespace("wt");
@Component({
  components: {
    wtVideo,
    wtImage,
    CustomPageSection
  }
})
export default class WtStoreDetail extends Vue {
  @storeManage.Action queryGitiCustomDetailRest: Function;
  @common.Action queryDataDictionaryListLang;
  @common.Action getDataValue;
  wtStoreStarTypeData = [];
  loading: boolean = false;
  store: any = {};

  memberType: any = "";
  marketType: any = "";
  showFinanceInfo: any = false;

  get formList() {
    let result: any = [
      {
        name: "基础信息",
        list: [
          {
            key: "门店编码",
            value: this.formatterStr(this.store.storeCode)
          },
          {
            key: "门店名称",
            value: this.formatterStr(this.store.storeName)
          },
          // {
          //   key: "K1分管业务",
          //   value: this.formatterStr("")
          // },
          {
            key: "星级",
            value:
              this.formatterStr(this.store.storeStarGrade) === "-"
                ? "-"
                : this.wtStoreStarTypeData.find(
                    (o) => o.value == this.store.storeStarGrade
                  ).label || '-',
          },
          {
            key: "门店类型",
            value: this.formatterStr(this.store.storeTagName)
          },
          {
            key: "联系人",
            value: this.formatterStr(this.store.managerUserName)
          },
          {
            key: "联系人手机",
            value: this.formatterStr(this.store.storeMobile)
          },
          // {
          //   key: "验收时间",
          //   value: this.formatterStr("")
          // },
          // {
          //   key: "协议到期日",
          //   value: this.formatterStr("")
          // },
          // {
          //   key: "是否电商",
          //   value: this.formatterStr("")
          // },
          // {
          //   key: "门店属性",
          //   value: this.formatterStr("")
          // },
          // {
          //   key: "签约目标",
          //   value: this.formatterStr("")
          // },
          // {
          //   key: "签约目标更新时间",
          //   value: this.formatterStr("")
          // },

          // {
          //   key: "二批任务",
          //   value: this.formatterStr("")
          // },
          // {
          //   key: "任务更新时间",
          //   value: this.formatterStr(""),
          // },
          {
            key: "备注",
            value: this.formatterStr(this.store.remarkName)
          },
          {
            key: "级别",
            value: this.formatterStr(this.store.levelName)
          },
          {
            key: "是否二批商",
            value:
              this.formatterStr(this.store.isK2AppM) === "-"
                ? "-"
                : this.store.isK2AppM == 1
                ? "是"
                : "否"
          },
          {
            key: "是否二批商更新时间",
            value: this.formatterStr(this.store.isK2AppMChangeTime)
          },
          {
            key: "门店目标",
            value: this.formatterStr(this.store.storeTargetStr),
            notShow: this.store.storeTagName == "注册店"
          },
          {
            key: "目标更新时间",
            value: this.formatterStr(this.store.targetUpdateTime),
            notShow: this.store.storeTagName == "注册店"
          }
        ]
      },
      {
        name: "财务信息",
        list: [
          {
            key: "星级成长值（近3月）",
            value: this.formatterStr(this.store.lastThreeMonthsGrowthValue),
          },
          {
            key: "星级成长值（前3月）",
            value: this.formatterStr(this.store.beforeThreeMonthsGrowthValue),
          },
          {
            key: "成长值更新时间",
            value: this.formatterStr(this.store.growthValueUpdateTime),
          },
          {
            key: "建店成长值（近6个月）",
            value: this.formatterStr(this.store.lastSixMonthsGrowthValue),
          },
          {
            key: "建店成长值（前6个月）",
            value: this.formatterStr(this.store.beforeSixMonthsGrowthValue),
          },
          {
            key: "奖励金更新时间",
            value: this.formatterStr(this.store.amountUpdateTime),
          },
          {
            key: "奖励金余额",
            value: this.formatterStr(this.store.accountAmount),
          },
          {
            key: "其中可用",
            value: this.formatterStr(this.store.usableAccountAmount),
          },
          {
            key: "其中待入账",
            value: this.formatterStr(this.store.pendingEntryAccountAmount)
          }
        ]
      },
      {
        name: "开户信息",
        list: [
          {
            key: "开户状态",
            value: this.formatterStr(this.store.accountOpenStatus),
          },
          {
            key: "首次签约时间",
            value: this.formatterStr(this.store.firstSignTime),
          },
          {
            key: "开户更新时间",
            value: this.formatterStr(this.store.applyUpdateTime),
          }
        ]
      }
    ];
    let financeList: any = [
      {
        key: "信用金额度",
        value: this.formatterStr(this.store.creditLimit)
      },
      {
        key: "信用金余额",
        value: this.formatterStr(this.store.creditBalance)
      },
      {
        key: "门店欠款",
        value: this.formatterStr(this.store.creditDebt)
      },
      {
        key: "信用金更新时间",
        value: this.formatterStr(this.store.creditUpdateTime)
      }
    ];
    if (this.showFinanceInfo) {
      result[1].list = [...result[1].list, ...financeList];
    }
    return result;
  }
  async created() {
    this.memberType = localStorage.getItem("memberType");
    this.marketType = localStorage.getItem("marketType");
  }
  async mounted() {
    try {
      this.loading = true;
      await this.getTypeData();
      await this.getStoreInfo();
      await this.getDic();
    } finally {
      this.loading = false;
    }
  }

  async getDic() {
    let res = await this.getDataValue({
      dataCode: "CREDIT_SWITCH"
    });
    if (
      res.dataValue === "1" &&
      this.memberType === "11" &&
      this.marketType === "PCR"
    ) {
      this.showFinanceInfo = true;
    }
  }
  async getTypeData() {
    this.wtStoreStarTypeData = await this.queryDataDictionaryListLang({
      statePath: "wtStoreStarTypeData",
      ddCode: "WT_STAR_TYPE"
    });
  }
  async getStoreInfo() {
    const { code } = this.$route.query;
    try {
      const data = await this.queryGitiCustomDetailRest({
        storeCode: code,
      });
      this.store = data || {};
    } catch (err) {
      console.log(err, "获取详情错误信息");
    }
  }
  formatterStr(str) {
    if (
      str === "" ||
      str === null ||
      str === undefined ||
      Array.isArray(str) && str.length === 0
    ) {
      return "-";
    } else {
      if (Array.isArray(str)) {
        return str.join("、")
      } else {
        return str;
      }
    }
  }
}
